import { render, staticRenderFns } from "./Workspaces.vue?vue&type=template&id=25fcac10"
import script from "./Workspaces.vue?vue&type=script&lang=ts"
export * from "./Workspaces.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports